import React, {PropTypes} from 'react';

const RowWithLabel = (props) => (
  <div className="row section">
    <div className="col-sm-12 item">
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-2 header-section text-style align-left">
              <div className="content">
                {props.label}
              </div>
            </div>
            <div className="col-sm-10 filter-section text-style">
              <div className="content" style={{textAlign: props.alignToLeft && 'left' }}>
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
export default RowWithLabel



// WEBPACK FOOTER //
// ./src/browser/components/stateless/RowWithLabel.react.js